import { motion, AnimatePresence } from 'framer-motion';
import { GOAL_LABELS } from '../../config/onboarding-steps';
import { useIsDesktop } from '../../hooks/useMediaQuery';
import type { OnboardingGoal } from '../../types/onboarding';

const GOALS: OnboardingGoal[] = [
  'communicate-better',
  'resolve-conflicts',
  'save-relationship',
  'empathy-superpower',
  'be-heard',
  'self-transformation',
];

interface GoalChipsProps {
  selectedGoal: OnboardingGoal | null;
  onSelect: (goal: OnboardingGoal) => void;
  onContinue: () => void;
}

export default function GoalChips({ selectedGoal, onSelect, onContinue }: GoalChipsProps) {
  const isDesktop = useIsDesktop();

  return (
    <div className="space-y-3">
      <div className={`grid gap-2 ${isDesktop ? 'grid-cols-2' : 'grid-cols-1'}`}>
        {GOALS.map((goal) => {
          const isSelected = selectedGoal === goal;
          return (
            <button
              key={goal}
              onClick={() => onSelect(goal)}
              className={`px-3 py-2 rounded-full text-sm text-left transition-all duration-200 border ${
                isSelected
                  ? 'border-primary bg-primary/10 text-primary font-medium'
                  : 'border-(--ee-tw-gray-200-line) bg-(--ee-tw-gray-50-bg) text-(--ee-tw-gray-700) hover:border-(--ee-tw-gray-300-line) hover:bg-(--ee-tw-gray-100-bg)'
              }`}
            >
              {GOAL_LABELS[goal]}
            </button>
          );
        })}
      </div>

      <AnimatePresence>
        {selectedGoal ? (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.2 }}
          >
            <button
              onClick={onContinue}
              className="w-full py-2.5 rounded-xl bg-primary text-(--ee-on-accent) font-medium text-sm hover:bg-primary/90 transition-colors"
            >
              Continue
            </button>
          </motion.div>
        ) : null}
      </AnimatePresence>
    </div>
  );
}
